// extracted by mini-css-extract-plugin
export default {"container":"_WN1avdk","inContent":"Vt20qmYI","mobile":"mobile","fullscreen":"NyX4e7UL","totalCount":"sy1wsKM6","count":"B3TlOWhu"};